import { NLPSearchResultFormat } from '../../../../ai-answer-dialog/types';
import { EditedDefinitionScope } from '../../curated/types';
export var getReferenceQueryOrLinkTitle = function getReferenceQueryOrLinkTitle(query) {
  var linkRegex = /spaces\/.*\/(pages|blog)/;
  if (query.match(linkRegex)) {
    // e.g. https://hello.atlassian.net/wiki/spaces/AAI/pages/3665fakeId/Test+Page+Title
    var queryParts = query.split('/');
    return queryParts[queryParts.length - 1];
  }
  return query;
};
export var getEntityIdInScope = function getEntityIdInScope(_ref) {
  var selectedScope = _ref.selectedScope,
    productScopes = _ref.productScopes,
    cloudId = _ref.cloudId;
  var contentARI = '';
  var spaceARI = '';
  var projectARI = '';
  if ('contentARI' in productScopes) {
    contentARI = productScopes.contentARI;
    spaceARI = productScopes.spaceARI;
  }
  if ('projectARI' in productScopes) {
    projectARI = productScopes.projectARI;
  }
  switch (selectedScope) {
    case EditedDefinitionScope.PAGE:
    case EditedDefinitionScope.BLOGPOST:
      return contentARI;
    case EditedDefinitionScope.SPACE:
      return spaceARI;
    case EditedDefinitionScope.PROJECT:
      return projectARI;
    default:
      return cloudId;
  }
};
export var mapCreatedDefinitionToNLPSearchType = function mapCreatedDefinitionToNLPSearchType(definitionDetails) {
  var _definitionReferenceD, _definitionDetails$ed, _definitionDetails$ed2;
  var definitionReferenceDetails = definitionDetails.confluenceEntity;
  return {
    nlpResult: definitionDetails.definition,
    uniqueSources: definitionDetails.confluenceEntity ? [{
      id: (definitionReferenceDetails === null || definitionReferenceDetails === void 0 ? void 0 : definitionReferenceDetails.id) || '',
      title: (definitionReferenceDetails === null || definitionReferenceDetails === void 0 ? void 0 : definitionReferenceDetails.title) || '',
      url: definitionDetails.referenceUrl || '',
      type: (definitionReferenceDetails === null || definitionReferenceDetails === void 0 ? void 0 : definitionReferenceDetails.type) || '',
      lastModified: '',
      iconUrl: '',
      spaceName: (definitionReferenceDetails === null || definitionReferenceDetails === void 0 || (_definitionReferenceD = definitionReferenceDetails.space) === null || _definitionReferenceD === void 0 ? void 0 : _definitionReferenceD.name) || '',
      spaceUrl: null
    }] : [],
    nlpResultEditor: {
      name: ((_definitionDetails$ed = definitionDetails.editor) === null || _definitionDetails$ed === void 0 ? void 0 : _definitionDetails$ed.name) || '',
      id: ((_definitionDetails$ed2 = definitionDetails.editor) === null || _definitionDetails$ed2 === void 0 ? void 0 : _definitionDetails$ed2.accountId) || ''
    },
    disclaimer: null,
    errorState: null,
    format: NLPSearchResultFormat.MARKDOWN
  };
};